import { useState } from "react";

import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import AvatarGroup from "@mui/material/AvatarGroup";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import ManageManagerEnrolementDialog from "./ManageManagerEnrolementDialog";
import ManageUserEnrolementDialog from "./ManageUserEnrolementDialog";
import UserAvatar from "../UserAvatar";

export default function AvatarGroupDialog(props) {
    const [open, setOpen] = useState(false);
    const isManagers = props.title === "Managers";

    function setDialogOpen(nextOpen) {
        setOpen(nextOpen);

        // Lets the page hide page-level UI while the enrolement dialog is up.
        if (props.onOpenChange) {
            props.onOpenChange(nextOpen);
        }
    }

    function handleOpenDialog() {
        setDialogOpen(true);
    }

    function onClose(selected, other, selectionHasChanged) {
        setDialogOpen(false);

        if (selectionHasChanged) {
            props.onChange(selected, other);
        }
    }

    return (
        <>
            <Box
                sx={{
                    minHeight: 190,
                    p: 2,
                    borderRadius: 2.5,
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid",
                    borderColor: "divider",
                    backgroundColor: "background.subtle",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 1.5,
                    }}
                >
                    {isManagers ? (
                        <ShieldOutlinedIcon sx={{ color: "primary.main" }} />
                    ) : (
                        <GroupsOutlinedIcon sx={{ color: "primary.main" }} />
                    )}
                    <Box>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 800, lineHeight: 1.2 }}
                        >
                            {props.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {props.selectedUsers.length} selected
                        </Typography>
                    </Box>
                </Box>

                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    {props.selectedUsers.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">
                            This hub does not have any{" "}
                            {props.title.toLowerCase()}.
                        </Typography>
                    ) : (
                        <AvatarGroup
                            max={5}
                            sx={{
                                justifyContent: "flex-end",
                                "& .MuiAvatar-root": {
                                    width: 42,
                                    height: 42,
                                },
                            }}
                        >
                            {props.selectedUsers.map((user) => (
                                <UserAvatar
                                    key={user.key}
                                    userOrHub={user}
                                    variant="circular"
                                    path="users"
                                    size="medium"
                                />
                            ))}
                        </AvatarGroup>
                    )}
                </Box>

                <Button
                    variant="outlined"
                    onClick={handleOpenDialog}
                    sx={{ mt: 1.5 }}
                >
                    Edit {props.title}
                </Button>
            </Box>

            {isManagers ? (
                <ManageManagerEnrolementDialog
                    open={open}
                    onClose={onClose}
                    selectedUsers={props.selectedUsers}
                    otherUsers={props.otherUsers}
                />
            ) : (
                <ManageUserEnrolementDialog
                    open={open}
                    onClose={onClose}
                    selectedUsers={props.selectedUsers}
                    otherUsers={props.otherUsers}
                />
            )}
        </>
    );
}
